<template>
  <div class="tw-flex tw-min-h-screen tw-flex-col tw-bg-light-gray">
    <div
      class="tw-relative tw-m-auto tw-flex tw-w-full tw-max-w-6xl tw-flex-1 tw-flex-col tw-px-4"
    >
      <!-- Header -->
      <div class="tw-flex tw-items-center tw-pt-5">
        <Logo type="timeful" />

        <v-spacer />

        <LandingPageHeader>
          <ThemeSwitcher />
          <LocaleSwitcher />
          <div v-if="authUser" class="tw-ml-2">
            <AuthUserMenu />
          </div>
          <v-btn v-else-if="signInEnabled" text :to="{ name: 'sign-in' }">{{
            $t("header.signIn")
          }}</v-btn>
        </LandingPageHeader>
      </div>

      <div
        class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-pb-24"
      >
        <div
          class="tw-mb-8 tw-flex tw-max-w-[26rem] tw-flex-col tw-items-center sm:tw-w-[35rem] sm:tw-max-w-none"
        >
          <div
            id="header"
            class="tw-mb-4 tw-text-center tw-text-2xl tw-font-medium sm:tw-text-4xl lg:tw-text-4xl xl:tw-text-5xl"
          >
            <h1>{{ $t("landing.title") }}</h1>
          </div>

          <div
            class="tw-text-center tw-text-sm tw-text-very-dark-gray sm:tw-text-lg"
          >
            {{ $t("landing.subtitle") }}
          </div>
        </div>

        <div class="tw-space-y-2">
          <v-btn
            class="tw-block tw-self-center tw-rounded-lg tw-bg-green tw-px-10 tw-text-base sm:tw-px-10 lg:tw-px-12"
            dark
            @click="authUser ? openDashboard() : (newDialog = true)"
            large
            :x-large="$vuetify.breakpoint.mdAndUp"
          >
            {{
              authUser ? $t("landing.openDashboard") : $t("landing.createEvent")
            }}
          </v-btn>
          <div
            v-if="!authUser"
            class="tw-text-center tw-text-xs tw-text-dark-gray sm:tw-text-sm"
          >
            {{ $t("landing.noLogin") }}
          </div>
        </div>
      </div>
    </div>

    <!-- Sign in dialog -->
    <SignInDialog
      v-model="signInDialog"
      @signIn="_signIn"
      @emailSignIn="_emailSignIn"
    />

    <!-- New event dialog -->
    <NewDialog v-model="newDialog" no-tabs @signIn="signIn" />
  </div>
</template>

<style scoped>
@media screen and (min-width: 375px) and (max-width: 640px) {
  #header {
    font-size: 1.875rem !important; /* 30px */
    line-height: 2.25rem !important; /* 36px */
  }
}
</style>

<script>
import { signInGoogle, signInOutlook } from "@/utils"
import NewDialog from "@/components/NewDialog.vue"
import LandingPageHeader from "@/components/landing/LandingPageHeader.vue"
import Logo from "@/components/Logo.vue"
import SignInDialog from "@/components/SignInDialog.vue"
import { calendarTypes } from "@/constants"
import { mapState, mapMutations } from "vuex"
import AuthUserMenu from "@/components/AuthUserMenu.vue"
import LocaleSwitcher from "@/components/general/LocaleSwitcher.vue"
import ThemeSwitcher from "@/components/general/ThemeSwitcher.vue"

export default {
  name: "Landing",

  metaInfo() {
    return {
      title: this.$t("landing.pageTitle"),
    }
  },

  components: {
    NewDialog,
    LandingPageHeader,
    Logo,
    SignInDialog,
    AuthUserMenu,
    LocaleSwitcher,
    ThemeSwitcher,
  },

  data: () => ({
    signInDialog: false,
    newDialog: false,
  }),

  computed: {
    signInEnabled() {
      return !!process.env.VUE_APP_GOOGLE_CLIENT_ID
    },
    ...mapState(["authUser"]),
  },

  methods: {
    ...mapMutations(["setAuthUser"]),
    _signIn(calendarType) {
      if (calendarType === calendarTypes.GOOGLE) {
        signInGoogle({ state: null, selectAccount: true })
      } else if (calendarType === calendarTypes.OUTLOOK) {
        // NOTE: selectAccount is not supported implemented yet for Outlook, maybe add it later
        signInOutlook({ state: null, selectAccount: true })
      }
    },
    _emailSignIn(user) {
      this.setAuthUser(user)
      this.$router.replace({ name: "home" })
    },
    signIn() {
      this.$router.push({ name: "sign-in" })
    },
    openDashboard() {
      this.$router.push({ name: "home" })
    },
  },
}
</script>
